import { useEffect, useState } from "react";


const useVersion = () => {

    const [version, setVersion] = useState<string | null>(null);

    useEffect(() => {
        fetch("https://api.stacher.io/api/update/mac/x64/6.0.0")
            .then(res => res.json())
            .then(data => {
                setVersion(data.version);
            })
            .catch(err => {
                setVersion(null);
            });
    }, []);

    return version;

}

export default useVersion;